/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_Legal_Name_LabelInputs */

const es_privacy_policy_contact_legal_name_label = /** @type {(inputs: Privacy_Policy_Contact_Legal_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre Legal`)
};

const en_privacy_policy_contact_legal_name_label = /** @type {(inputs: Privacy_Policy_Contact_Legal_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Name`)
};

/**
* | output |
* | --- |
* | "Legal Name" |
*
* @param {Privacy_Policy_Contact_Legal_Name_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_legal_name_label = /** @type {((inputs?: Privacy_Policy_Contact_Legal_Name_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_Legal_Name_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_legal_name_label(inputs)
	return en_privacy_policy_contact_legal_name_label(inputs)
});
export { privacy_policy_contact_legal_name_label as "privacy_policy.contact.legal_name_label" }